"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function truncate(value, decimals) {
    if (decimals === void 0) { decimals = 1; }
    var divisor = 1;
    var decimalMod = 0;
    var postFix = '';
    if (value >= 1000) {
        divisor = 1000;
        postFix = 'K';
    }
    if (value >= 1000000) {
        divisor = 1000000;
        decimalMod = decimalMod + 2;
        postFix = 'M';
    }
    if (value >= 1000000000) {
        divisor = 1000000000;
        decimalMod = decimalMod + 2;
        postFix = 'B';
    }
    return (value / divisor).toFixed(decimalMod) + postFix;
}
exports.truncate = truncate;
//# sourceMappingURL=Truncate.js.map